import styled from 'styled-components';
import { Palette } from 'config';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  height: 100%;
`;

export const Border = styled.div`
  border-radius: 50%;
  border: 2px solid ${Palette.Primary._300};
`;

export const ProgressBar = styled.div`
  border: 2px solid ${Palette.PrimaryGray._100};
  position: relative;
  width: ${({ width }) => width && `${width}px`};
  height: ${({ height }) => height && `${height}px`};
  border-radius: 50%;
  overflow: hidden;
`;

export const Text = styled.span`
  color: ${Palette.Primary._500};
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;
